import { useState } from 'react';
import { useActiveBrand } from '../../shared/theme';
import { BrandShield } from './icons';

/**
 * Het woordmerk van het product (MRK-2).
 *
 * Voor de productnaam van UP2D8 het woordmerk uit de mockup: "UP", het middenstuk "2D" in de
 * tweede merkkleur, "8". Een andere productnaam is gewoon tekst - het middenstuk is een vondst van
 * één logo, geen regel voor elke naam.
 */
export function ProductWordmark({ accentClassName }: { accentClassName?: string }) {
  const { productName, isDefaultProduct } = useActiveBrand();
  if (!isDefaultProduct) return <>{productName}</>;
  return (
    <>
      {productName.slice(0, 2)}
      <span className={accentClassName}>{productName.slice(2, 4)}</span>
      {productName.slice(4)}
    </>
  );
}

/**
 * Het merk op een donkere ondergrond: de zijbalk van de schil (B.3) en het merkvlak van het
 * aanmeldscherm (spec 01).
 *
 * Met een productlogo voor een donkere ondergrond (`productLogoDarkUrl`) staat dat logo er, en
 * niets anders: een logo draagt zijn eigen naam. Zonder het schild en de productnaam als tekst -
 * met de productnaam van UP2D8 precies het huidige ontwerp.
 *
 * Een ondertekende URL uit het eerste beeld (`localStorage`) kan verlopen zijn. Laadt de afbeelding
 * niet, dan staat het schild er tot de verse URL binnen is.
 */
export function ProductBrand({ variant }: { variant: 'sidebar' | 'auth' }) {
  const { productName, productLogoDarkUrl } = useActiveBrand();
  const [broken, setBroken] = useState<string | null>(null);

  if (productLogoDarkUrl && broken !== productLogoDarkUrl) {
    return (
      <img
        src={productLogoDarkUrl}
        alt={productName}
        className={variant === 'sidebar' ? 'sidebar-brand-logo' : 'a-auth-logo'}
        data-testid="product-logo"
        onError={() => setBroken(productLogoDarkUrl)}
      />
    );
  }

  if (variant === 'sidebar') {
    return (
      <>
        <div className="sidebar-brand-shield">
          <BrandShield />
        </div>
        <div className="sidebar-brand-text" data-testid="product-name">
          <ProductWordmark />
        </div>
      </>
    );
  }

  return (
    <>
      <div className="sidebar-brand-shield" style={{ width: 40, height: 40 }}>
        <BrandShield />
      </div>
      <span data-testid="product-name">
        <ProductWordmark accentClassName="c" />
      </span>
    </>
  );
}
